export default __webpack_public_path__ + "static/media/rocket_scroll.1e686b18.png";